module.exports = __webpack_public_path__ + "static/cover2-90c6b6a24eb327ef20d07839ea0c68fa.png";